import React from "react";
import { getStyle, notFilledInputClass, notFilledSelectClass, regularInputClass, regularSelectClass } from "../../../../styles/styles";
import { Dialog, DialogContent, IconButton, withStyles } from "@material-ui/core";
import { validateEmail2 } from "../../../../helpers/ValidateHelper";
import { sendAuthorizedCustomerEmail } from "../../../../networking/NetworkingCustomers";
import DynamicSelect from "../../../shared/DynamicSelect";
import LoadingBox from "../../../shared/LoadingBox";
import AlertBox from "../../../shared/AlertBox";
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { LookUpTables } from "../../../../constants/LookUpTables";

var style = getStyle();

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
            </IconButton>
        ) : null}
        </MuiDialogTitle>
    );
});

export default class WelcomeEmailFormDialog extends React.Component {
    state = {
        language: "",
        title: 'Welcome Email',
        //
        customerContactSelected: 0,
        email: "",
        additionalEmail: "",
        affiliateEmail: "",
        //
        emailChecked: false,
        additionalEmailChecked: false,
        affiliateEmailChecked: false,
        //
        emailDisabled: true,
        additionalEmailDisabled: true,
        affiliateEmailDisabled: true,
        //
        listLanguages: [],
        loading: false,
        //
        showAlert: false,
        alertMessage: '',
        alertTitle: '',
        messageList: [],
        //
        showAlertEmail: false,
        alertMessageEmail: '',
        alertTitleEmail: '',
        //
        validations: {
            language: true,
            email: true,
            additionalEmail: true,
            affiliateEmail: true
        },
        
        showEmail               : true,
        showAffiliateEmail      : true
    }

    async componentDidUpdate(prevProps) {
        if(this.props !== prevProps) {
            if (this.props.lookUpTables != null && this.props.lookUpTables !== prevProps.lookUpTables) {
                let languages = this.props.lookUpTables                
                    
                languages.forEach(element => {
                    element.value = element.LookUpTableDetail;
                    element.name = element.LookUpTableDetail;
                });
                this.setState({listLanguages: languages})
            }
            if(this.props.customerEmail !== undefined && this.props.customerEmail !== null &&
                this.props.customerEmail !== prevProps.customerEmail
            ) {
                this.setState({email: this.props.customerEmail});
            }
            if(this.props.affiliateEmail !== undefined && this.props.affiliateEmail !== null &&
                this.props.affiliateEmail !== prevProps.affiliateEmail) {
                this.setState({affiliateEmail: this.props.affiliateEmail});
            }
            if(this.props.clientConfirmation !== undefined && this.props.clientConfirmation !== null &&
                this.props.clientConfirmation !== prevProps.clientConfirmation) {
                this.setState({showEmail: this.props.clientConfirmation});
            }
            if(this.props.introducerConfirmation !== undefined && this.props.introducerConfirmation !== null &&
                this.props.introducerConfirmation !== prevProps.introducerConfirmation) {
                this.setState({showAffiliateEmail: this.props.introducerConfirmation});
            }
        }
    }

    componentDidMount() {
        if (this.props.lookUpTables != null) {
            let languages = this.props.lookUpTables;
        
            languages.forEach(element => {
                element.value = element.LookUpTableDetail;
                element.name = element.LookUpTableDetail;
            });
            this.setState({listLanguages: languages})
        }
        if(this.props.customerEmail !== undefined && this.props.customerEmail !== null) {
            this.setState({email: this.props.customerEmail});
        }
        if(this.props.affiliateEmail !== undefined && this.props.affiliateEmail !== null) {
            this.setState({affiliateEmail: this.props.affiliateEmail});
        }
        if(this.props.clientConfirmation !== undefined && this.props.clientConfirmation !== null) {
            this.setState({showEmail: this.props.clientConfirmation});
        }
        if(this.props.introducerConfirmation !== undefined && this.props.introducerConfirmation !== null) {
            this.setState({showAffiliateEmail: this.props.introducerConfirmation});
        }
    }

    onCloseDialog = () => {
        this.setState({}, () => this.props.onClose());
    }

    handleSendWelcomeEmail = async () => {
        this.setState({
            showAlertEmail: false, alertTitleEmail: '', alertMessageEmail: '', loading: true
        });

        var resultValidateFields = this.validateRequiredFields();
        var r1 = resultValidateFields[0];
        var r2 = resultValidateFields[1];

        if (!r1)
        {
            if(r2.length > 0)
            {
                this.setState({
                    showAlert      : true,
                    alertTitle     : 'Error',
                    alertMessage   : 'Please fill all mandatory fields:',
                    messageList    : r2
                });
            }
            return;
        }

        if (!this.state.emailChecked && !this.state.additionalEmailChecked && !this.state.affiliateEmailChecked) 
        {
            this.setState({
                showAlert: true,
                alertTitle: 'Error',
                alertMessage: 'Please select who to send the confirmation to.'
            });
            return;
        }

        let emailReceiver = '';
        if (this.state.emailChecked && this.state.email !== '') {
            emailReceiver = emailReceiver + this.state.email + ';';
        }
        if (this.state.additionalEmailChecked && this.state.additionalEmail !== '') {
            emailReceiver = emailReceiver + this.state.additionalEmail + ';';
        }
        if (this.state.affiliateEmailChecked && this.state.affiliateEmail !== '') {
            emailReceiver = emailReceiver + this.state.affiliateEmail + ';';
        }

        let json = await sendAuthorizedCustomerEmail(this.props.customerId, emailReceiver);
        this.setState({loading: false});
        switch (Number(json.httpStatusCode)) {
            case 200: {
                this.setState({ showAlert: true, alertTitle: 'Success', alertMessage: 'Welcome email successfully sent.' });
                break;
            }
            default: {
                this.setState({ showAlert: true, alertTitle: 'Error', alertMessage: json.Message });
                break;
            }
        }
    }

    validateRequiredFields() 
    {
        let valid = true;
        let validLanguage = true, validEmail = true, validCustomerContactSelected = true, validAdditionalEmail = true, validAffiliateEmail = true;
        let messages = [];

        if (this.stringEmptyOrNull(this.state.language) || this.state.language.includes('Select')) {
            validLanguage = false;
        }
        
        if (this.state.emailChecked && this.stringEmptyOrNull(this.state.email)) {
            validEmail = false;
        }

        if (this.state.additionalEmailChecked && this.stringEmptyOrNull(this.state.additionalEmail)) {
            validAdditionalEmail = false;
        }else
        {
            if(this.state.additionalEmailChecked && !validateEmail2(this.state.additionalEmail))
            {
                validAdditionalEmail = false;
                messages.push('Enter a valir Additional Email');
            }
        }

        if (this.state.affiliateEmailChecked && this.stringEmptyOrNull(this.state.affiliateEmail)) {
            validAffiliateEmail = false;
        }else
        {
            if(this.state.affiliateEmailChecked && !validateEmail2(this.state.affiliateEmail))
            {
                validAffiliateEmail = false;
                messages.push('Enter a valir Affiliate Email');
            }
        }

        valid = validLanguage && validEmail && validCustomerContactSelected && validAdditionalEmail && validAffiliateEmail;

        this.setState({
            validations: {
                ...this.state.validations,
                language: validLanguage,
                email: validEmail,
                additionalEmail: validAdditionalEmail
            }
        });

        return [valid, messages];
    }

    handleEmailChecked = (event) => {
        let checked = event.target.checked;
        this.setState({emailChecked: checked})
    }

    handleEmail = (event) => {
        this.setState({email: event.target.value});
    }

    handleAdditionalEmailChecked = (event) => {
        let checked = event.target.checked;
        this.setState({
            additionalEmailDisabled: !checked, 
            additionalEmail: '', 
            additionalEmailChecked: checked,
            validations: { 
                ...this.state.validations, 
                additionalEmail: !checked? true: this.state.validations.additionalEmail
            }
        });
    }

    handleAdditionalEmail = (event) => {
        this.setState({additionalEmail: event.target.value, validations: { ...this.state.validations, additionalEmail: true }});
    }

    handleAffiliateEmailChecked = (event) => {
        let checked = event.target.checked;
        this.setState({ affiliateEmailChecked: checked });
    }

    handleAffiliateEmail = (event) => {
        this.setState({affiliateEmail: event.target.value, validations: { ...this.state.validations, affiliateEmail: true }});
    }

    handleLanguage(value){
        if (typeof value !== undefined && value !== undefined) 
        {
            switch (typeof value) {
                case 'object':
                {
                    this.setState({language: value !== null ? value.value : ''});
                    break;
                }
                case 'string':
                {
                    this.setState({language: value !== null ? value : ''});
                    break;
                }
            }
        }
    }

    //alerts
    closeAlert = () => {
        this.setState({showAlert: false, alertMessage: '', alertTitle: '', messageList: []})
    }

    closeAlertEmail = () => {
        this.setState({showAlertEmail: false, alertMessageEmail: '', alertTitleEmail: ''})
    }
    
    //validations
    formatValidSelect(valid) {
        return valid ? regularSelectClass : notFilledSelectClass;
    }
    
    formatValidInput(valid) {
        return valid ? regularInputClass : notFilledInputClass;
    }
    
    stringEmptyOrNull(str){
        return (str === null || str === '')
    }

    render() {
        return (
            <Dialog 
                open        = {this.props.open} 
                onClose     = {this.props.onClose}
                fullWidth   = {true}
                maxWidth    = {false}
                style       = {{
                    width: '30%',
                    margin: 'auto',
                    minWidth: '400px'
                }}
            >
                <DialogTitle 
                    id="welcome-email-dialog-gwlatr-title"
                    onClose={this.onCloseDialog}
                >
                    {this.state.title}
                </DialogTitle>
                <DialogContent dividers style={{paddingLeft:24, overflowY: 'visible'}}>
                    <div className="uk-grid">
                        <div className="uk-width-1-1">
                            <label className="uk-form-label">Language:</label>
                            <DynamicSelect className={this.formatValidSelect(this.state.validations.language)} id="form-welcome-email-language" data={this.state.listLanguages} 
                                    objValue={{value: this.state.language}} getValue={this.handleLanguage.bind(this)} />
                        </div>
                        {this.state.showEmail && <div className={"uk-width-1-1"} style={{paddingTop: 10}}>
                            <input className="uk-checkbox  uk-margin-right" type="checkbox" id="form-welcome-email-emailcheck" onChange={this.handleEmailChecked} 
                                checked={this.state.emailChecked}/>
                            <label className="uk-form-label" >Email</label>
                            <input 
                                className   = {this.formatValidInput(this.state.validations.email)} 
                                type        = "text" 
                                id          = "form-welcome-email-email" 
                                value       = {this.state.email} 
                                onChange    = {this.handleEmail} 
                                disabled    = {this.state.emailDisabled}
                            />
                        </div>}
                        {this.state.showAffiliateEmail && <div className={"uk-width-1-1"} style={{paddingTop: 10}}>
                            <input className="uk-checkbox  uk-margin-right" type="checkbox" id="form-welcome-email-AffiliateEmailcheck" onChange={this.handleAffiliateEmailChecked}/>
                            <label className="uk-form-label" >Affiliate/Introducer Email</label>
                            <div style={{display:'flex', flexDirection:'row'}}>
                                <input 
                                    className={this.formatValidInput(this.state.validations.affiliateEmail)} 
                                    type="text" id="form-welcome-email-affiliateEmail" 
                                    value={this.state.affiliateEmail} 
                                    onChange={this.handleAffiliateEmail} 
                                    disabled={true}
                                />
                            </div>
                        </div>}
                        <div className={"uk-width-1-1"} style={{paddingTop: 10}}>
                            <input className="uk-checkbox uk-margin-right" type="checkbox" id="form-welcome-email-additionalEmailCheck" onChange={this.handleAdditionalEmailChecked}/>
                            <label className="uk-form-label" >Additional Email</label>
                            <div style={{display:'flex', flexDirection:'row'}}>
                                <input 
                                    className={this.formatValidInput(this.state.validations.additionalEmail)} 
                                    type="text" id="form-dealconfirmation-additionalemail" 
                                    value={this.state.additionalEmail} 
                                    onChange={this.handleAdditionalEmail} 
                                    disabled={this.state.additionalEmailDisabled}
                                />
                            </div>
                        </div>

                        <div className="uk-width-1-2"></div>

                        <div className="uk-width-1-1" style={{paddingTop: 20, marginBottom:0}}>
                            <button 
                                className   = "uk-button uk-button-default uk-button-green" 
                                type        = "button" 
                                onClick     = {this.handleSendWelcomeEmail}
                            >Send Email</button>
                            <button 
                                className="uk-button uk-button-green uk-float-right" 
                                type="button" 
                                onClick={this.onCloseDialog}
                            >close</button>
                        </div>
                    </div>
                </DialogContent>
                <AlertBox 
                    open    = {this.state.showAlert} 
                    onClose = {this.closeAlert} 
                    type    = "Ok" 
                    title   = {this.state.alertTitle} 
                    message = {this.state.alertMessage} 
                    okClick = {this.closeAlert}
                    messageBoldList = {this.state.messageList}
                />
                
                <AlertBox 
                    open    = {this.state.showAlertEmail} 
                    onClose = {this.closeAlertEmail} 
                    type    = "Yes/No" 
                    title   = {this.state.alertTitleEmail} 
                    message = {this.state.alertMessageEmail} 
                    noClick = {this.closeAlertEmail} 
                    yesClick= {this.handleSendWelcomeEmail}
                />
                <LoadingBox loading={this.state.loading}/>
            </Dialog>
        )
    }
}